import React from 'react';
import styled from 'styled-components';
import { RETRIEVAL_DICTATION_SEPARATOR } from '../../../constants/constants';
import { getRetrievalTagValue } from '../../../utils/tagValidatorUtils';

type FeedbackType<T = Record<string, string>> = T;

const extractData = (
  input: string | null
): { myReflection: string; jsonObject: FeedbackType } => {
  const regexPattern = `^(.*?)\\s*${RETRIEVAL_DICTATION_SEPARATOR}\\s*(\\{.*\\})$`;
  const match = input?.match(new RegExp(regexPattern));

  if (match) {
    const myReflection = match[1].trim();
    const jsonString = match[2];
    const jsonObject: FeedbackType = JSON.parse(jsonString);

    return { myReflection, jsonObject };
  }

  return { myReflection: '', jsonObject: {} };
};

interface ContainerProps {
  $source: string;
}

const Container = styled.div<ContainerProps>`
  width: 100%;
  margin-top: 10px;
  box-sizing: border-box;
  font-size: ${(props) =>
    props.$source === 'recentFlags' || props.$source == 'highlightPopup'
      ? 'var(--font-size-400)'
      : 'var(--font-size-600)'};
`;

const Title = styled.div`
  color: var(--color-soft-purple);
  margin-bottom: 6px;
  font-weight: 700;
`;

const FeedbackList = styled.div``;

const FeedbackItem = styled.div`
  display: flex;
  color: var(--color-medium-gray);
`;

const FeedbackKey = styled.span<ContainerProps>`
  width: ${(props) => (props.$source == 'highlightPopup' ? '120px' : '160px')};
  margin-right: 10px;
  font-weight: 700;
`;

const FeedbackValue = styled.span`
  flex: 1;
`;

const ReflectionTitle = styled.div`
  margin-top: 12px;
  margin-bottom: 6px;
  font-weight: 700;
  color: var(--color-gray);
`;

const ReflectionText = styled.div<ContainerProps>`
  color: var(--color-soft-gray);
  color: ${(props) =>
    props.$source == 'highlightPopup'
      ? 'var(--color-deep-gray)'
      : 'var(--color-soft-gray)'};
`;

interface RetrievalFeedbackProps {
  tag: string | null | undefined;
  dictation: string | null;
  source: string;
}

const RetrievalFeedback: React.FC<RetrievalFeedbackProps> = ({
  tag,
  dictation,
  source
}) => {
  const { myReflection, jsonObject } = extractData(dictation);

  return (
    <Container $source={source}>
      {Object.entries(jsonObject).length > 0 && (
        <>
          <Title>{getRetrievalTagValue(tag)?.toUpperCase()} FEEDBACK</Title>
          <FeedbackList>
            {Object.entries(jsonObject).map(([key, value]) => (
              <FeedbackItem key={key}>
                <FeedbackKey $source={source}>{key}:</FeedbackKey>
                <FeedbackValue>{value}</FeedbackValue>
              </FeedbackItem>
            ))}
          </FeedbackList>
        </>
      )}
      {myReflection && (
        <>
          <ReflectionTitle>MY REFLECTION</ReflectionTitle>
          <ReflectionText $source={source}>{myReflection}</ReflectionText>
        </>
      )}
    </Container>
  );
};

export default RetrievalFeedback;
